





















































import { Vue, Component, Prop } from "vue-property-decorator";
import { ImageState } from "./BackgroundImageService";

@Component({})

export default class ImageComponent extends Vue {
    @Prop({ required: true }) image: ImageState;

    get $s() {
        return this.$style
    }

    close() {
        this.$emit('close');
    }

    retry() {
        this.$emit('retry')
    }

    get closable() {
        return !this.image.onLoad;
    }
}

